// BeatStars logo mark (Simple Icons, CC0) — red by default to match the site.
const BeatStarsIcon = ({ size = 28, color = "#DF0000" }: { size?: number; color?: string }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill={color} role="img" aria-hidden="true" style={{ flexShrink: 0, display: "block" }}>
    <path d="m17.217 11.996-3.308 1.079v3.478l-2.052-2.818-3.309 1.079 2.043-2.818-2.043-2.819 3.31 1.08 2.05-2.819v3.487zm0 0v7.277H6.854V4.584h10.363v7.412l4.585-1.49v-7.67L19.135 0H2.198v24h16.92l2.684-2.685v-7.83z" />
  </svg>
);

export default BeatStarsIcon;
